export default (initialState = {}) => {
  return () => {
    return {
      is_against_bill: true,
      used_credits: 0,
      is_used_credits: false,
      adjustments: 0,
      remarks: "",
      seller: null,
      status_cd: "",
      bill_id: null,
      pod_id: null,
      po_id: null,
      invc_id: null,
      bill_number: "",
      invc_number: "",
      request_against: "",
      bill_date: null,
      invc_date: null,
      pod_stamp_date: null,
      lineitems: [],
      net_amount: 0,
      net_payable: 0,
      is_advance: true,
      requestor: null,
      total_amount: 0,
      total_tax: 0,
      total_amount_wt: 0,
      approvers: [],
      tds: {
        code: "",
        percentage: 0,
        amount: 0,
      },
      percentage_pay: 100,
      payment_has_tax: true,
      payments_made: 0,
      associated_payments: [],
      pod: null,
      source: "web",
      financial_summary: {
        outstanding_payables: 0,
        unused_credits: 0,
        balance: 0,
      },
      payment_received_date: null,
      ...initialState,
    };
  };
};
